import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loadScriptByURL, saveSessionToken } from '../../utils';
import { VerifyCodeOtp } from '../../pages';
import { useAuthService, AuthContext } from '../../hooks';

const DEFAULT_TIME = 60;
const recaptchaKey = '6LcgYzUeAAAAAMzXJ7ddC57PNtA0k-stcLituAZE';
const resendChannels = { WhatsApp: 'whatsapp', SMS: 'telefono', correo: 'correo' };
const resendError = 'No pudimos reenviar el código. Intenta de nuevo.';
const wrongCodeError = 'El código no es correcto. Revísalo e intenta de nuevo.';
const verifyError = 'No pudimos verificar el código. Intenta de nuevo.';

function VerifyCodeOtpContainer() {
  const [code, setCode] = useState('');
  const [errorMsgs, setErrorMsgs] = useState(null);
  const [userInformation, setUserInfo] = useState({});
  const [time, setTime] = useState(DEFAULT_TIME);
  const [openDialog, setOpenDialog] = useState(false);
  const [sentBy, setSentBy] = useState(null);
  const [verifying, setVerifying] = useState(false);
  const { verifyCodeService, loginService } = useAuthService();
  const { verify } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { state } = location;
    setUserInfo(state);
    setSentBy(state?.medio === 'telefono' ? 'whatsapp' : state?.medio);
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`,
      () => {},
    );
  }, [location]);

  const generateToken = async ({ captcha, medio }) => {
    const channel = resendChannels[medio];
    const response = await loginService({
      captcha,
      valor: userInformation.valor,
      medio: channel,
    });
    if (response?.uuid) {
      setUserInfo((prev) => ({ ...prev, uuid: response.uuid }));
      setSentBy(channel);
      setErrorMsgs(null);
    } else {
      setErrorMsgs(resendError);
    }
  };

  const handleSubmit = (event) => {
    if (userInformation.medio === 'correo') {
      event.preventDefault();
      setTime(DEFAULT_TIME);
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(recaptchaKey, { action: 'submit' })
          .then((token) => {
            generateToken({ captcha: token, medio: 'correo' });
          });
      });
    } else {
      setOpenDialog(true);
    }
  };

  const handleSubmitDialog = (event) => {
    setTime(DEFAULT_TIME);
    setOpenDialog(false);
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(recaptchaKey, { action: 'submit' })
        .then((token) => {
          generateToken({ captcha: token, medio: event });
        });
    });
  };
  const handleCloseDialog = () => setOpenDialog(false);

  const verifyCode = async (event, tokenCaptcha) => {
    try {
      const { uuid } = userInformation;
      const response = await verifyCodeService({
        captcha: tokenCaptcha,
        otp: event.toString(),
        uuid,
        plataforma_id: 2,
      });
      if (response?.token) {
        verify(response.token);
        saveSessionToken(response.token);
        navigate('../map', {
          replace: true,
          state: {
            valor: response.token,
          },
        });
        return;
      }
      setCode('');
      setErrorMsgs(wrongCodeError);
    } catch (error) {
      setCode('');
      setErrorMsgs(verifyError);
    } finally {
      setVerifying(false);
    }
  };

  const handleChange = (event) => {
    setCode(event);
    setErrorMsgs(null);
    if (event.length === 4) {
      setVerifying(true);
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(recaptchaKey, { action: 'submit' })
          .then((token) => verifyCode(event, token));
      });
    }
  };

  const onBack = () => navigate('/', { replace: true });

  const remainTime = () => {
    const minutes = Math.floor(time / 60);
    const seconds = time - minutes * 60;
    let totalSecs = seconds;
    if (seconds < 10) {
      totalSecs = `0${seconds}`;
    }
    return `${minutes}:${totalSecs}`;
  };

  useEffect(() => {
    const playingTimer = setTimeout(() => {
      if (time > 0) {
        setTime(time - 1);
      }
    }, 1000);
    return () => {
      clearTimeout(playingTimer);
    };
  }, [time]);

  return (
    <VerifyCodeOtp
      code={code}
      errorMsgs={errorMsgs}
      remainTime={remainTime}
      openDialog={openDialog}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      userInformation={userInformation}
      sentBy={sentBy}
      verifying={verifying}
      onBack={onBack}
      handleCloseDialog={handleCloseDialog}
      handleSubmitDialog={handleSubmitDialog}
    />
  );
}

export default VerifyCodeOtpContainer;
